import React, { useRef } from 'react';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';

import { UserCoreInviteConfirm, UserCoreInviteConfirmVariables } from './__generated__/UserCoreInviteConfirm';

import { LayoutDefault, Loading } from '../../shared/ui';
import { useQueryParams } from '../../shared/router';
import { auth } from '../../shared/auth';
import { useResetCurrentUserAndHistoryPush } from '../../shared/user';

const PATH_INVITE_CONFIRM_LANDING = '/sign-up/password';

const USER_CORE_INVITE_CONFIRM = gql`
  mutation UserCoreInviteConfirm($input: UserInviteConfirmInput!) {
    userCoreInviteConfirm(input: $input) {
      token
    }
  }
`;

function Invite() {
  const queryParams = useQueryParams();
  const code = queryParams.get('code');
  if (!code) {
    throw new Error('Code is not found in query params');
  }
  const resetCurrentUserAndHistoryPush = useResetCurrentUserAndHistoryPush();
  const [userCoreInviteConfirm] = useMutation<UserCoreInviteConfirm, UserCoreInviteConfirmVariables>(
    USER_CORE_INVITE_CONFIRM
  );
  const ref = useRef<boolean>();

  // Run only on first render
  if (!ref.current) {
    ref.current = true;

    const input = { code };
    userCoreInviteConfirm({ variables: { input: input } }).then((result) => {
      return auth.authenticate(result.data!.userCoreInviteConfirm!.token).then(() => {
        resetCurrentUserAndHistoryPush(PATH_INVITE_CONFIRM_LANDING);
      });
    });
  }

  return (
    <LayoutDefault>
      <h2>Invite</h2>
      <Loading />
    </LayoutDefault>
  );
}

export { Invite };
